import vm from '@/main'  ///导入VUE实例
import store from "store/index"; ///导入公共仓库


////控制区域页面显示数据 公共的请求方法
const regionPageDataRequest = (regionId) => {

    return new Promise((resolve, reject) => {

        vm.$request({
            method: "post",
            url: "/home/findRegionPage",
            data: {
                token: vm.$store.state.token,
                regionId: regionId,
            }
        })
            .then(res => {
                if (res.data.code != 0) {
                    vm.$showTipsToast(3, res.data.message);
                    ////说明信息填写错误,控制失败了，
                    return;
                } else {
                    ////、控制成功了
                    //////返回服务器数据
                    // console.log(res.data.data)
                    resolve(res.data.data)
                }
            })
            .catch(error => {
                console.log(error);
            });


        // resolve(a1);////成功返回的对象
        // reject(a2);  ////失败返回的对象

    });
}



















export {
    regionPageDataRequest

}